import { _ as _defineProperty, a as _inherits, b as _createClass, c as _objectWithoutProperties, d as _objectSpread2, e as _classCallCheck, f as _callSuper } from '../_helpers/_rollupPluginBabelHelpers.js';
import 'core-js/modules/es.array.concat.js';
import { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import chevronDownIcon from '@jetbrains/icons/chevron-down';
import Icon from '../icon/icon.js';
import ClickableLink from '../link/clickableLink.js';
import { ControlsHeightContext } from '../global/controls-height.js';
import { g as getButtonClasses, m as modules_e81895c9 } from '../_helpers/button__classes.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Size } from '../icon/icon__constants.js';
import 'util-deprecate';
import '../_helpers/icon__svg.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.string.starts-with.js';
import '../global/memoize.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.map.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.weak-map.js';
import 'core-js/modules/web.dom-collections.iterator.js';

var _excluded = ["active", "danger", "delayed", "loader", "primary", "short", "text", "inline", "dropdown", "height", "icon", "iconSize", "iconClassName", "iconSuppressSizeWarning", "className", "children"];
var Button = /*#__PURE__*/function (_PureComponent) {
  function Button() {
    var _this;
    _classCallCheck(this, Button);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Button, [].concat(args));
    _defineProperty(_this, "buttonRef", /*#__PURE__*/createRef());
    return _this;
  }
  _inherits(Button, _PureComponent);
  return _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        active = _this$props.active,
        danger = _this$props.danger,
        delayed = _this$props.delayed,
        loader = _this$props.loader,
        primary = _this$props.primary,
        short = _this$props.short,
        text = _this$props.text,
        inline = _this$props.inline,
        dropdown = _this$props.dropdown,
        _this$props$height = _this$props.height,
        height = _this$props$height === void 0 ? this.context : _this$props$height,
        icon = _this$props.icon,
        iconSize = _this$props.iconSize,
        iconClassName = _this$props.iconClassName,
        iconSuppressSizeWarning = _this$props.iconSuppressSizeWarning,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutProperties(_this$props, _excluded);
      var classes = getButtonClasses({
        className,
        active,
        danger,
        delayed,
        icon,
        loader,
        primary,
        short,
        text,
        inline,
        height
      });
      var content = /*#__PURE__*/jsxs("span", {
        className: modules_e81895c9.content,
        children: [icon && /*#__PURE__*/jsx("span", {
          className: classNames(modules_e81895c9.icon, iconClassName),
          children: /*#__PURE__*/jsx(Icon, {
            glyph: icon,
            size: iconSize,
            loading: loader,
            suppressSizeWarning: iconSuppressSizeWarning
          })
        }), children && /*#__PURE__*/jsx("span", {
          children: children
        }), dropdown && /*#__PURE__*/jsx(Icon, {
          glyph: chevronDownIcon,
          className: modules_e81895c9.dropdownIcon
        })]
      });
      var commonProps = _objectSpread2(_objectSpread2({
        tabIndex: loader ? -1 : 0
      }, props), {}, {
        className: classes,
        children: /*#__PURE__*/jsxs(Fragment, {
          children: [loader && !text && !icon && /*#__PURE__*/jsx("div", {
            className: modules_e81895c9.loaderBackground
          }), content]
        })
      });
      return commonProps.href != null ? /*#__PURE__*/jsx(ClickableLink, _objectSpread2({}, commonProps)) : /*#__PURE__*/jsx("button", _objectSpread2({
        ref: this.buttonRef,
        type: "button"
      }, commonProps));
    }
  }]);
}(PureComponent);
_defineProperty(Button, "propTypes", {
  active: PropTypes.bool,
  danger: PropTypes.bool,
  delayed: PropTypes.bool,
  loader: PropTypes.bool,
  primary: PropTypes.bool,
  short: PropTypes.bool,
  text: PropTypes.bool,
  inline: PropTypes.bool,
  dropdown: PropTypes.bool,
  href: PropTypes.string,
  target: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  iconSize: PropTypes.number,
  iconClassName: PropTypes.string,
  iconSuppressSizeWarning: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func
});
_defineProperty(Button, "IconSize", Size);
_defineProperty(Button, "contextType", ControlsHeightContext);

export { Button, Size as IconSize, Button as default };
